var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00244141,
    width: 40.0026,
    height: 40.0026,
    rx: 10.6663,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1593 10.0024C28.8341 10.0024 31.8233 12.9917 31.8233 16.6676V24.643C31.8233 28.3178 28.8341 31.3082 25.1593 31.3082H15.5537C11.8789 31.3082 8.88855 28.3178 8.88855 24.643V16.6676C8.88855 12.9917 11.8789 10.0024 15.5537 10.0024H25.1593ZM25.1593 11.6693H15.5537C12.7979 11.6693 10.5554 13.9118 10.5554 16.6676V24.643C10.5554 27.3988 12.7979 29.6413 15.5537 29.6413H25.1593C27.9151 29.6413 30.1565 27.3988 30.1565 24.643V24.3318L26.4917 24.3325C24.3837 24.3325 22.668 22.6179 22.6669 20.5109C22.6669 18.4018 24.3826 16.6861 26.4917 16.685L30.1565 16.6843V16.6676C30.1565 13.9118 27.9151 11.6693 25.1593 11.6693ZM30.1565 18.3512L26.4917 18.3518C25.3016 18.3529 24.3337 19.3208 24.3337 20.5098C24.3337 21.6977 25.3027 22.6656 26.4917 22.6656L30.1565 22.665V18.3512ZM27.0002 19.6075C27.4603 19.6075 27.8337 19.9809 27.8337 20.4409C27.8337 20.901 27.4603 21.2744 27.0002 21.2744H26.6535C26.1935 21.2744 25.8201 20.901 25.8201 20.4409C25.8201 19.9809 26.1935 19.6075 26.6535 19.6075H27.0002ZM20.7621 15.0453C21.2222 15.0453 21.5955 15.4187 21.5955 15.8788C21.5955 16.3388 21.2222 16.7122 20.7621 16.7122H14.7625C14.3025 16.7122 13.9291 16.3388 13.9291 15.8788C13.9291 15.4187 14.3025 15.0453 14.7625 15.0453H20.7621Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletNav);
export default __webpack_public_path__ + "static/media/wallet-nav.7c2f93d4fc11ee33821ea3d0864b7267.svg";
export { ForwardRef as ReactComponent };